import React from 'react';
import PropTypes from 'prop-types';

import OrderProduct from 'components/account/Order/OrderProduct';
import BackNav from 'components/account/BackNav';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/order/cancelOrReturnItemSelect.scss';

/* Separate Cancel/Return Item Selection page for Mobile when cancelling/returning item from the Order Detail page. */
export const CancelOrReturnItemSelect = ({ type, order, selectedItems, onHideItemSelect, onToggleItemSelect, onSubmit }) => {
  const { orderId, lineItems } = order;
  const { testId } = useMartyContext();
  const items = lineItems.filter(item => {
    const { cancellable, returnable } = item;
    switch (type) {
      case 'cancel':
        return cancellable === true;
      case 'return':
        return returnable === true;
      default:
        return false;
    }
  });

  return (
    <div className={css.wrap}>
      <div className={css.backNav}>
        <BackNav onClick={onHideItemSelect} to={`/orders/${orderId}`}>
          Order Details
        </BackNav>
      </div>
      <h1>
        Select Items to <span>{type}</span>
      </h1>
      {items.map(lineItem => {
        const { itemUniqueId, amount, product, legacy } = lineItem;

        return (
          <div key={itemUniqueId} className={css.item} data-test-id={testId(`${type}Item`)}>
            <input
              type="checkbox"
              id={`${type}-${itemUniqueId}`}
              onChange={onToggleItemSelect.bind(this, lineItem, orderId)}
              data-test-id={testId(`${type}Input`)}
            />
            <label htmlFor={`${type}-${itemUniqueId}`} aria-label={type} />
            <OrderProduct product={product} price={amount} isLegacy={legacy} hideWriteReview={true} />
          </div>
        );
      })}
      <div className={css.submitBtn}>
        <button type="button" onClick={onSubmit} disabled={!selectedItems.length} data-test-id={testId(`${type}ItemsButton`)}>
          {type} selected items
        </button>
      </div>
    </div>
  );
};

CancelOrReturnItemSelect.propTypes = {
  order: PropTypes.object.isRequired
};

CancelOrReturnItemSelect.displayName = 'CancelOrReturnItemSelect';

export default CancelOrReturnItemSelect;
